import { Share2, Copy, Mail } from "lucide-react";
import { toast } from "sonner";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";

export const SITE_URL = "https://carsalemarket.com";
export const SITE_TEXT = "Explore India's premium pre-owned car marketplace to buy and sell directly with owners and dealers!";

const X = (p) => <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M18.9 2H22l-7.6 8.7L23 22h-6.8l-5.3-6.9L4.8 22H1.7l8.1-9.3L1 2h6.9l4.8 6.4L18.9 2Zm-1.2 18h1.9L6.4 4H4.4l13.3 16Z" /></svg>;
const FB = (p) => <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M13.5 22v-8h2.7l.4-3.2h-3.1V8.8c0-.9.3-1.6 1.6-1.6h1.7V4.4c-.3 0-1.3-.1-2.5-.1-2.5 0-4.1 1.5-4.1 4.2v2.3H7.4V14h2.8v8h3.3Z" /></svg>;
const WA = (p) => <svg viewBox="0 0 24 24" fill="currentColor" {...p}><path d="M17.5 14.4c-.3-.1-1.7-.8-2-.9-.3-.1-.5-.1-.7.1-.2.3-.8.9-.9 1.1-.2.2-.3.2-.6.1-.3-.1-1.2-.5-2.3-1.4-.9-.8-1.4-1.7-1.6-2-.2-.3 0-.5.1-.6l.4-.5c.2-.2.2-.3.3-.5.1-.2 0-.4 0-.5l-.9-2.1c-.2-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4s1 2.8 1.2 3c.1.2 2 3.1 4.9 4.3.7.3 1.2.5 1.6.6.7.2 1.3.2 1.8.1.6-.1 1.7-.7 1.9-1.4.2-.7.2-1.2.2-1.4-.1-.1-.3-.2-.6-.3ZM12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2Z" /></svg>;

export function shareLinks(url, text) {
  const u = encodeURIComponent(url), t = encodeURIComponent(text), both = encodeURIComponent(`${text} ${url}`);
  return [
    ["WhatsApp", WA, `https://wa.me/?text=${both}`],
    ["Facebook", FB, `https://www.facebook.com/sharer/sharer.php?u=${u}`],
    ["X", X, `https://twitter.com/intent/tweet?text=${t}&url=${u}`],
    ["Email", Mail, `mailto:?subject=${encodeURIComponent("CarSaleMarket.com")}&body=${both}`],
  ];
}

export default function ShareButton({ url = SITE_URL, title = "CarSaleMarket.com", text = SITE_TEXT, children, className = "", testid = "share-btn" }) {
  const native = async (e) => {
    e.preventDefault(); e.stopPropagation();
    if (navigator.share) {
      try { await navigator.share({ title, text, url }); } catch { /* user cancelled */ }
      return true;
    }
    return false;
  };
  const copy = async () => {
    try { await navigator.clipboard.writeText(url); } catch {
      const ta = document.createElement("textarea"); ta.value = url; document.body.appendChild(ta); ta.select(); document.execCommand("copy"); ta.remove();
    }
    toast.success("Link Copied!");
  };

  if (typeof navigator !== "undefined" && navigator.share) {
    return <button type="button" onClick={native} className={className} aria-label="Share" data-testid={testid}>{children || <Share2 className="w-3.5 h-3.5" />}</button>;
  }
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button type="button" onClick={(e) => e.stopPropagation()} className={className} aria-label="Share" data-testid={testid}>{children || <Share2 className="w-3.5 h-3.5" />}</button>
      </PopoverTrigger>
      <PopoverContent align="end" onClick={(e) => e.stopPropagation()} className="w-64 p-3 bg-[#111319] border-[#D4AF37]/30 text-white space-y-2" data-testid={`${testid}-menu`}>
        <p className="text-xs text-gray-400 line-clamp-2">{text}</p>
        <button onClick={(e) => { e.preventDefault(); copy(); }} className="btn-gold w-full text-xs !py-2" data-testid={`${testid}-copy`}><Copy className="w-3.5 h-3.5" />Copy Link</button>
        <div className="grid grid-cols-4 gap-2">
          {shareLinks(url, text).map(([name, Icon, href]) => (
            <a key={name} href={href} target="_blank" rel="noopener noreferrer" onClick={(e) => e.stopPropagation()} className="flex flex-col items-center gap-1 text-[10px] text-gray-300 hover:text-[#E5C158]" data-testid={`${testid}-${name.toLowerCase()}`}>
              <span className="w-9 h-9 rounded-full border border-white/10 flex items-center justify-center"><Icon className="w-4 h-4" /></span>{name}
            </a>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}

export const carShare = (car) => ({
  url: `${window.location.origin}/cars/${car.id}`,
  title: `${car.year} ${car.brand} ${car.model}`,
  text: `Check out this ${car.year} ${car.brand} ${car.model} on CarSaleMarket.com:`,
});
